import { Link } from '@tanstack/react-router';

import type { EditorialItem } from '@/lib/queries/browse';

/**
 * An editorial article card inside the "From the editorial" row. Headline is
 * serif (§3 permits serif for article headlines). NEW uses the browse oxblood
 * fill; POPULAR is an oxblood-muted outline. Links to the existing article
 * reader route.
 */
export function ArticleCard({ item }: { item: EditorialItem }) {
  return (
    <Link
      to="/articles/$slug"
      params={{ slug: item.slug }}
      className="block rounded-md bg-video-card p-4 ring-1 ring-video-line transition hover:ring-video-line-strong"
    >
      {item.badge === 'NEW' ? (
        <span className="inline-block rounded-sm bg-oxblood-browse px-1.5 py-0.5 font-sans text-[0.65rem] uppercase tracking-[0.12em] text-video-text">
          New
        </span>
      ) : (
        <span className="inline-block rounded-sm border border-oxblood-muted px-1.5 py-0.5 font-sans text-[0.65rem] uppercase tracking-[0.12em] text-oxblood-muted">
          Popular
        </span>
      )}
      <h3 className="mt-2 font-serif text-lg text-video-text">{item.title}</h3>
      {item.excerpt && (
        <p className="mt-1 line-clamp-2 font-sans text-sm text-video-text-muted">{item.excerpt}</p>
      )}
      <span className="mt-2 inline-block font-sans text-xs text-silver">Read more →</span>
    </Link>
  );
}
